import { render, staticRenderFns } from "./ProductIssueDetail.vue?vue&type=template&id=b46507ce&"
import script from "./ProductIssueDetail.vue?vue&type=script&lang=js&"
export * from "./ProductIssueDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductIssueDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports